"use client";

// Form
import { c as _c } from "react/compiler-runtime";
import { Button, ButtonVariant, Checkbox, Input, Text, TextColor, TextVariant } from "@workspace/ui/components";
import { Form, Formik } from "formik";
import { omit } from "lodash";
import { useRouter } from "next/navigation";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

// Context

import { useCustomer } from "@/context";
import validationSchema from "./validationSchema";
const AddressForm = t0 => {
  const $ = _c(27);
  const {
    addressDetails,
    noRedirect: t1,
    onSuccess
  } = t0;
  const noRedirect = t1 === undefined ? false : t1;
  const [companyAddress, setCompanyAddress] = useState(!!(addressDetails?.company || addressDetails?.vatNumber));
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      unauthorized: false,
      success: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [status, setStatus] = useState(t2);
  const {
    updateAddress,
    createAddress
  } = useCustomer();
  const formRef = useRef(null);
  let t3;
  if ($[1] !== addressDetails || $[2] !== companyAddress) {
    t3 = () => {
      if (addressDetails && formRef.current) {
        formRef.current.setFieldValue("alias", addressDetails.alias);
        formRef.current.setFieldValue("company", addressDetails.company);
        formRef.current.setFieldValue("firstName", addressDetails.firstname);
        formRef.current.setFieldValue("lastName", addressDetails.lastname);
        formRef.current.setFieldValue("address1", addressDetails.address1);
        formRef.current.setFieldValue("address2", addressDetails.address2);
        formRef.current.setFieldValue("postcode", addressDetails.postcode);
        formRef.current.setFieldValue("city", addressDetails.city);
        formRef.current.setFieldValue("phone", addressDetails.phone);
        formRef.current.setFieldValue("country", addressDetails.country);
        formRef.current.setFieldValue("vatNumber", addressDetails.vatNumber);
        formRef.current.setFieldValue("companyAddress", companyAddress);
      }
    };
    $[1] = addressDetails;
    $[2] = companyAddress;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== addressDetails) {
    t4 = [addressDetails];
    $[4] = addressDetails;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== companyAddress) {
    t5 = {
      alias: "M\xF3j adres",
      company: "",
      vatNumber: "",
      firstName: "",
      lastName: "",
      address1: "",
      address2: "",
      postcode: "",
      city: "",
      phone: "",
      country: "Polska",
      idCountry: "14",
      companyAddress
    };
    $[6] = companyAddress;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const initialValues = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = validationSchema();
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const formSchema = t6;
  const router = useRouter();
  const t7 = addressDetails?.id ? "Adres zosta\u0142 zaktualizowany" : "Adres zosta\u0142 dodany";
  let t8;
  if ($[9] !== t7) {
    t8 = {
      unauthorized: "Nie uda\u0142o si\u0119 doda\u0107 adresu",
      success: t7
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const statusContent = t8;
  let t9;
  if ($[11] !== addressDetails?.id || $[12] !== createAddress || $[13] !== noRedirect || $[14] !== onSuccess || $[15] !== router || $[16] !== status || $[17] !== updateAddress) {
    t9 = (values, t10) => {
      const {
        setSubmitting
      } = t10;
      const preparedValues = omit(values, "companyAddress");
      if (addressDetails?.id) {
        updateAddress(addressDetails?.id, preparedValues).then(res => {
          if (res.status === 200) {
            setSubmitting(false);
            setStatus({
              ...status,
              success: true
            });
            toast.success("Adres zosta\u0142 zaktualizowany");
            setTimeout(() => {
              setStatus({
                ...status,
                success: false
              });
              if (!noRedirect) {
                router.push("/adresy");
              }
              if (onSuccess) {
                onSuccess();
              }
            }, 2000);
          }
          if (res.status === 307) {
            setSubmitting(false);
            setStatus({
              ...status,
              unauthorized: true
            });
            toast.error("Brakuje dane wymagane do aktualizacji");
            setTimeout(() => {
              setStatus({
                ...status,
                unauthorized: false
              });
            }, 2000);
          }
          if (res.status === 303) {
            setSubmitting(false);
            setStatus({
              ...status,
              unauthorized: true
            });
            toast.error("Nieprawid\u0142owe dane adresowe");
            setTimeout(() => {
              setStatus({
                ...status,
                unauthorized: false
              });
            }, 2000);
          }
        });
      } else {
        createAddress(preparedValues).then(res_0 => {
          if (res_0.success) {
            setSubmitting(false);
            setStatus({
              ...status,
              success: true
            });
            toast.success("Adres zosta\u0142 dodany");
            setTimeout(() => {
              setStatus({
                ...status,
                success: false
              });
              if (!noRedirect) {
                router.push("/adresy");
              }
              if (onSuccess) {
                onSuccess();
              }
            }, 2000);
          }
        });
      }
    };
    $[11] = addressDetails?.id;
    $[12] = createAddress;
    $[13] = noRedirect;
    $[14] = onSuccess;
    $[15] = router;
    $[16] = status;
    $[17] = updateAddress;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== companyAddress || $[20] !== status || $[21] !== statusContent) {
    t10 = t11 => {
      const {
        values: values_0,
        touched,
        errors,
        setFieldValue,
        isSubmitting
      } = t11;
      return <AccountFormWrapper className="py-6">{Object.values(status).indexOf(true) > -1 && <InfoBar $error={status.unauthorized} $success={status.success}><Text variant={TextVariant.P} text={Object.values(statusContent)[Object.values(status).indexOf(true)]} color={status.success ? TextColor.SPECIAL_700 : TextColor.ERROR_500} /></InfoBar>}<FormWrapper><Input autoFocus={true} id="alias" value={values_0.alias} name="alias" label="Alias" placeholder={"Wprowad\u017A alias"} focused={touched.alias} validated={typeof errors.alias === "undefined" && touched.alias} error={typeof errors.alias !== "undefined" && touched.alias} errorHelper={errors.alias} onChange={e => setFieldValue("alias", e.target.value)} icon={false} type="text" autoComplete="off" /><Input id="firstName" value={values_0.firstName} name="firstName" label={"Imi\u0119"} placeholder={"Wprowad\u017A imi\u0119"} focused={touched.firstName} validated={typeof errors.firstName === "undefined" && touched.firstName} error={typeof errors.firstName !== "undefined" && touched.firstName} errorHelper={errors.firstName} onChange={e_0 => setFieldValue("firstName", e_0.target.value)} icon={false} type="text" autoComplete="off" /><Input id="lastName" value={values_0.lastName} name="lastName" label="Nazwisko" placeholder={"Wprowad\u017A nazwisko"} focused={touched.lastName} validated={typeof errors.lastName === "undefined" && touched.lastName} error={typeof errors.lastName !== "undefined" && touched.lastName} errorHelper={errors.lastName} onChange={e_1 => setFieldValue("lastName", e_1.target.value)} icon={false} type="text" autoComplete="off" /><div className="flex gap-4"><Input id="address1" value={values_0.address1} name="address1" label="Adres" placeholder={"Wprowad\u017A adres"} focused={touched.address1} validated={typeof errors.address1 === "undefined" && touched.address1} error={typeof errors.address1 !== "undefined" && touched.address1} errorHelper={errors.address1} onChange={e_2 => setFieldValue("address1", e_2.target.value)} icon={false} type="text" autoComplete="off" className="!w-3/5" /><Input id="address2" value={values_0.address2} name="address2" label="Numer mieszkania" placeholder={"Wprowad\u017A numer mieszkania"} focused={touched.address2} validated={typeof errors.address2 === "undefined" && touched.address2} error={typeof errors.address2 !== "undefined" && touched.address2} errorHelper={errors.address2} onChange={e_3 => setFieldValue("address2", e_3.target.value)} icon={false} type="text" autoComplete="off" className="!w-2/5" /></div><div className="flex gap-4"><Input id="postcode" value={values_0.postcode} name="postcode" label="Kod pocztowy" placeholder={"Wprowad\u017A kod pocztowy"} focused={touched.postcode} validated={typeof errors.postcode === "undefined" && touched.postcode} error={typeof errors.postcode !== "undefined" && touched.postcode} errorHelper={errors.postcode} onChange={e_4 => setFieldValue("postcode", e_4.target.value)} icon={false} type="text" autoComplete="off" mask="##-###" className="!w-1/5" /><Input id="city" value={values_0.city} name="city" label="Miasto" placeholder={"Wprowad\u017A miasto"} focused={touched.city} validated={typeof errors.city === "undefined" && touched.city} error={typeof errors.city !== "undefined" && touched.city} errorHelper={errors.city} onChange={e_5 => setFieldValue("city", e_5.target.value)} icon={false} type="text" autoComplete="off" className="!w-4/5" /></div><Input id="country" value={values_0.country} name="country" label="Kraj" placeholder={"Wprowad\u017A kraj"} focused={touched.country} validated={typeof errors.country === "undefined" && touched.country} error={typeof errors.country !== "undefined" && touched.country} errorHelper={errors.country} onChange={e_6 => setFieldValue("country", e_6.target.value)} icon={false} type="text" autoComplete="off" disabled={true} /><Input id="phone" value={values_0.phone} name="phone" label="Telefon" placeholder={"Wprowad\u017A telefon"} focused={touched.phone} validated={typeof errors.phone === "undefined" && touched.phone} error={typeof errors.phone !== "undefined" && touched.phone} errorHelper={errors.phone} onChange={e_7 => setFieldValue("phone", e_7.target.value)} icon={false} type="text" autoComplete="off" mask="+48 ### ### ###" /><Checkbox id="companyAddress" name="companyAddress" label="Adres firmowy" checked={companyAddress} onChange={e_8 => {
            if (!e_8.target.checked) {
              setFieldValue("company", "");
              setFieldValue("vatNumber", "");
            }
            setCompanyAddress(e_8.target.checked);
            setFieldValue("companyAddress", e_8.target.checked);
          }} justifyStart={true} />{companyAddress && <><Input autoFocus={true} id="company" value={values_0.company} name="company" label="Firma" placeholder={"Wprowad\u017A nazw\u0119 firmy"} focused={touched.company} validated={typeof errors.company === "undefined" && touched.company} error={typeof errors.company !== "undefined" && touched.company} errorHelper={errors.company} onChange={e_9 => setFieldValue("company", e_9.target.value)} icon={false} type="text" autoComplete="off" /><Input autoFocus={true} id="vatNumber" value={values_0.vatNumber} name="vatNumber" label="NIP" placeholder={"Wprowad\u017A numer NIP"} focused={touched.vatNumber} validated={typeof errors.vatNumber === "undefined" && touched.vatNumber} error={typeof errors.vatNumber !== "undefined" && touched.vatNumber} errorHelper={errors.vatNumber} onChange={e_10 => setFieldValue("vatNumber", e_10.target.value)} icon={false} type="text" autoComplete="off" helperText={"NIP jest niezb\u0119dny do wystawienia faktury VAT"} /></>}<ButtonsWrapper><Button type="submit" variant={ButtonVariant.PRIMARY} text="Zapisz adres" disabled={isSubmitting} loading={isSubmitting} /></ButtonsWrapper></FormWrapper></AccountFormWrapper>;
    };
    $[19] = companyAddress;
    $[20] = status;
    $[21] = statusContent;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== initialValues || $[24] !== t10 || $[25] !== t9) {
    t11 = <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={t9} innerRef={formRef}>{t10}</Formik>;
    $[23] = initialValues;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
const InfoBar = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  padding: 2px 10px;

  ${({
  theme,
  $error
}) => $error && `
    background-color: ${theme.colors.ERROR_400};
  `}

  ${({
  theme,
  $success
}) => $success && `
    background-color: ${theme.colors.SPECIAL_300};
  `}
`;
const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  .MuiFormGroup-root {
    margin-bottom: 0;
    margin-right: 16px;
    width: 100%;
  }

  button {
    width: 100%;
  }

  .MuiFormGroup-root {
    margin-bottom: 16px;
  }
`;
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;

  button {
    width: fit-content;
    padding: 8px 32px;
  }

  ${({
  theme
}) => theme.mediaQueries.sm} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;
const AccountFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 600px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    max-width: 100%;
  }
`;
export default AddressForm;